/*                                                 *\
** ----------------------------------------------- **
**          Calliope - Pixos Game Engine   	       **
** ----------------------------------------------- **
**  Copyright (c) 2020-2022 - Kyle Derby MacInnis  **
**                                                 **
**    Any unauthorized distribution or transfer    **
**       of this work is strictly prohibited.      **
**                                                 **
**               All Rights Reserved.              **
** ----------------------------------------------- **
\*                                                 */

// Tileset Schema
export default {
  // Flat - Walkability -- All
  FLAT_ALL: {
    vertices: [
      [
        [0, 1, 0],
        [1, 1, 0],
        [1, 0, 0],
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 0],
      ],
    ],
    surfaces: [
      [
        [0, 1],
        [1, 1],
        [1, 0],
      ],
      [
        [0, 1],
        [1, 0],
        [0, 0],
      ],
    ],
    type: parseInt("1111", 2),
  },
  // Flat - Walkability -- None
  FLAT_NONE: {
    vertices: [
      [
        [0, 1, 0],
        [1, 1, 0],
        [1, 0, 0],
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 0],
      ],
    ],
    surfaces: [
      [
        [0, 1],
        [1, 1],
        [1, 0],
      ],
      [
        [0, 1],
        [1, 0],
        [0, 0],
      ],
    ],
    type: parseInt("0000", 2),
  },
  // Stairs
  STAIR_R: {
    vertices: [
      [
        [0.25, 0, 0.25],
        [0.25, 1, 0.25],
        [0.5, 1, 0.25],
      ],
      [
        [0.25, 0, 0.25],
        [0.5, 1, 0.25],
        [0.5, 0, 0.25],
      ],
      [
        [0.5, 0, 0.5],
        [0.5, 1, 0.5],
        [0.75, 1, 0.5],
      ],
      [
        [0.5, 0, 0.5],
        [0.75, 1, 0.5],
        [0.75, 0, 0.5],
      ],
      [
        [0.75, 0, 0.75],
        [0.75, 1, 0.75],
        [1, 1, 0.75],
      ],
      [
        [0.75, 0, 0.75],
        [1, 1, 0.75],
        [1, 0, 0.75],
      ],
      [
        [0.25, 0, 0],
        [0.25, 1, 0],
        [0.25, 1, 0.25],
      ],
      [
        [0.25, 0, 0],
        [0.25, 1, 0.25],
        [0.25, 0, 0.25],
      ],
      [
        [0.5, 0, 0.25],
        [0.5, 1, 0.25],
        [0.5, 1, 0.5],
      ],
      [
        [0.5, 0, 0.25],
        [0.5, 1, 0.5],
        [0.5, 0, 0.5],
      ],
      [
        [0.75, 0, 0.5],
        [0.75, 1, 0.5],
        [0.75, 1, 0.75],
      ],
      [
        [0.75, 0, 0.5],
        [0.75, 1, 0.75],
        [0.75, 0, 0.75],
      ],
      [
        [1, 0, 0.75],
        [1, 1, 0.75],
        [1, 1, 1],
      ],
      [
        [1, 0, 0.75],
        [1, 1, 1],
        [1, 0, 1],
      ],
      [
        [0, 0, 0],
        [1, 0, 0],
        [1, 0, 1],
      ],
      [
        [0, 0, 0],
        [1, 0, 1],
        [0, 0, 1],
      ],
      [
        [0, 1, 0],
        [1, 1, 0],
        [1, 1, 1],
      ],
      [
        [0, 1, 0],
        [1, 1, 1],
        [0, 1, 1],
      ],
    ],
    surfaces: [
      [
        [0, 0.75],
        [1, 0.75],
        [1, 0.5],
      ],
      [
        [0, 0.75],
        [1, 0.5],
        [0, 0.5],
      ],
      [
        [0, 0.5],
        [1, 0.5],
        [1, 0.25],
      ],
      [
        [0, 0.5],
        [1, 0.25],
        [0, 0.25],
      ],
      [
        [0, 0.25],
        [1, 0.25],
        [1, 0],
      ],
      [
        [0, 0.25],
        [1, 0.0],
        [0, 0],
      ],
      [
        [0, 2],
        [1, 2],
        [1, 1.75],
      ],
      [
        [0, 2],
        [1, 1.75],
        [0, 1.75],
      ],
      [
        [0, 1.75],
        [1, 1.75],
        [1, 1.5],
      ],
      [
        [0, 1.75],
        [1, 1.5],
        [0, 1.5],
      ],
      [
        [0, 1.5],
        [1, 1.5],
        [1, 1.25],
      ],
      [
        [0, 1.5],
        [1, 1.25],
        [0, 1.25],
      ],
      [
        [0, 1.25],
        [1, 1.25],
        [1, 1],
      ],
      [
        [0, 1.25],
        [1, 1],
        [0, 1],
      ],
      [
        [-1, 2],
        [0, 2],
        [0, 1],
      ],
      [
        [-1, 2],
        [0, 1],
        [-1, 1],
      ],
      [
        [-1, 2],
        [0, 2],
        [0, 1],
      ],
      [
        [-1, 2],
        [0, 1],
        [-1, 1],
      ],
    ],
    walkPoly: [
      [
        [0, 1, 0],
        [1, 1, 1],
        [1, 0, 1],
      ],
      [
        [0, 1, 0],
        [1, 0, 1],
        [0, 0, 0],
      ],
    ],
    type: parseInt("0101", 2),
  },
  STAIR_T: {
    vertices: [
      [
        [0, 0.75, 0.25],
        [1, 0.75, 0.25],
        [1, 0.5, 0.25],
      ],
      [
        [0, 0.75, 0.25],
        [1, 0.5, 0.25],
        [0, 0.5, 0.25],
      ],
      [
        [0, 0.5, 0.5],
        [1, 0.5, 0.5],
        [1, 0.25, 0.5],
      ],
      [
        [0, 0.5, 0.5],
        [1, 0.25, 0.5],
        [0, 0.25, 0.5],
      ],
      [
        [0, 0.25, 0.75],
        [1, 0.25, 0.75],
        [1, 0, 0.75],
      ],
      [
        [0, 0.25, 0.75],
        [1, 0, 0.75],
        [0, 0, 0.75],
      ],
      [
        [0, 0.75, 0],
        [1, 0.75, 0],
        [1, 0.75, 0.25],
      ],
      [
        [0, 0.75, 0],
        [1, 0.75, 0.25],
        [0, 0.75, 0.25],
      ],
      [
        [0, 0.5, 0.25],
        [1, 0.5, 0.25],
        [1, 0.5, 0.5],
      ],
      [
        [0, 0.5, 0.25],
        [1, 0.5, 0.5],
        [0, 0.5, 0.5],
      ],
      [
        [0, 0.25, 0.5],
        [1, 0.25, 0.5],
        [1, 0.25, 0.75],
      ],
      [
        [0, 0.25, 0.5],
        [1, 0.25, 0.75],
        [0, 0.25, 0.75],
      ],
      [
        [0, 0, 0.75],
        [1, 0, 0.75],
        [1, 0, 1],
      ],
      [
        [0, 0, 0.75],
        [1, 0, 1],
        [0, 0, 1],
      ],
      [
        [0, 1, 0],
        [0, 0, 0],
        [0, 0, 1],
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [0, 1, 1],
      ],
      [
        [1, 1, 0],
        [1, 0, 0],
        [1, 0, 1],
      ],
      [
        [1, 1, 0],
        [1, 0, 1],
        [1, 1, 1],
      ],
    ],
    surfaces: [
      [
        [0, 0.75],
        [1, 0.75],
        [1, 0.5],
      ],
      [
        [0, 0.75],
        [1, 0.5],
        [0, 0.5],
      ],
      [
        [0, 0.5],
        [1, 0.5],
        [1, 0.25],
      ],
      [
        [0, 0.5],
        [1, 0.25],
        [0, 0.25],
      ],
      [
        [0, 0.25],
        [1, 0.25],
        [1, 0],
      ],
      [
        [0, 0.25],
        [1, 0.0],
        [0, 0],
      ],
      [
        [0, 2],
        [1, 2],
        [1, 1.75],
      ],
      [
        [0, 2],
        [1, 1.75],
        [0, 1.75],
      ],
      [
        [0, 1.75],
        [1, 1.75],
        [1, 1.5],
      ],
      [
        [0, 1.75],
        [1, 1.5],
        [0, 1.5],
      ],
      [
        [0, 1.5],
        [1, 1.5],
        [1, 1.25],
      ],
      [
        [0, 1.5],
        [1, 1.25],
        [0, 1.25],
      ],
      [
        [0, 1.25],
        [1, 1.25],
        [1, 1],
      ],
      [
        [0, 1.25],
        [1, 1],
        [0, 1],
      ],
      [
        [-1, 2],
        [0, 2],
        [0, 1],
      ],
      [
        [-1, 2],
        [0, 1],
        [-1, 1],
      ],
      [
        [-1, 2],
        [0, 2],
        [0, 1],
      ],
      [
        [-1, 2],
        [0, 1],
        [-1, 1],
      ],
    ],
    walkPoly: [
      [
        [0, 1, 0],
        [1, 1, 0],
        [1, 0, 1],
      ],
      [
        [0, 1, 0],
        [1, 0, 1],
        [0, 0, 1],
      ],
    ],
    type: parseInt("1010", 2),
  },
  STAIR_L: {
    vertices: [
      [
        [0.75, 1, 0.25],
        [0.75, 0, 0.25],
        [0.5, 0, 0.25],
      ],
      [
        [0.75, 1, 0.25],
        [0.5, 0, 0.25],
        [0.5, 1, 0.25],
      ],
      [
        [0.5, 1, 0.5],
        [0.5, 0, 0.5],
        [0.25, 0, 0.5],
      ],
      [
        [0.5, 1, 0.5],
        [0.25, 0, 0.5],
        [0.25, 1, 0.5],
      ],
      [
        [0.25, 1, 0.75],
        [0.25, 0, 0.75],
        [0, 0, 0.75],
      ],
      [
        [0.25, 1, 0.75],
        [0, 0, 0.75],
        [0, 1, 0.75],
      ],
      [
        [0.75, 1, 0],
        [0.75, 0, 0],
        [0.75, 0, 0.25],
      ],
      [
        [0.75, 1, 0],
        [0.75, 0, 0.25],
        [0.75, 1, 0.25],
      ],
      [
        [0.5, 1, 0.25],
        [0.5, 0, 0.25],
        [0.5, 0, 0.5],
      ],
      [
        [0.5, 1, 0.25],
        [0.5, 0, 0.5],
        [0.5, 1, 0.5],
      ],
      [
        [0.25, 1, 0.5],
        [0.25, 0, 0.5],
        [0.25, 0, 0.75],
      ],
      [
        [0.25, 1, 0.5],
        [0.25, 0, 0.75],
        [0.25, 1, 0.75],
      ],
      [
        [0, 1, 0.75],
        [0, 0, 0.75],
        [0, 0, 1],
      ],
      [
        [0, 1, 0.75],
        [0, 0, 1],
        [0, 1, 1],
      ],
      [
        [1, 1, 0],
        [0, 1, 0],
        [0, 1, 1],
      ],
      [
        [1, 1, 0],
        [0, 1, 1],
        [1, 1, 1],
      ],
      [
        [1, 0, 0],
        [0, 0, 0],
        [0, 0, 1],
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [1, 0, 1],
      ],
    ],
    surfaces: [
      [
        [0, 0.75],
        [1, 0.75],
        [1, 0.5],
      ],
      [
        [0, 0.75],
        [1, 0.5],
        [0, 0.5],
      ],
      [
        [0, 0.5],
        [1, 0.5],
        [1, 0.25],
      ],
      [
        [0, 0.5],
        [1, 0.25],
        [0, 0.25],
      ],
      [
        [0, 0.25],
        [1, 0.25],
        [1, 0],
      ],
      [
        [0, 0.25],
        [1, 0.0],
        [0, 0],
      ],
      [
        [0, 2],
        [1, 2],
        [1, 1.75],
      ],
      [
        [0, 2],
        [1, 1.75],
        [0, 1.75],
      ],
      [
        [0, 1.75],
        [1, 1.75],
        [1, 1.5],
      ],
      [
        [0, 1.75],
        [1, 1.5],
        [0, 1.5],
      ],
      [
        [0, 1.5],
        [1, 1.5],
        [1, 1.25],
      ],
      [
        [0, 1.5],
        [1, 1.25],
        [0, 1.25],
      ],
      [
        [0, 1.25],
        [1, 1.25],
        [1, 1],
      ],
      [
        [0, 1.25],
        [1, 1],
        [0, 1],
      ],
      [
        [-1, 2],
        [0, 2],
        [0, 1],
      ],
      [
        [-1, 2],
        [0, 1],
        [-1, 1],
      ],
      [
        [-1, 2],
        [0, 2],
        [0, 1],
      ],
      [
        [-1, 2],
        [0, 1],
        [-1, 1],
      ],
    ],
    walkPoly: [
      [
        [0, 1, 1],
        [1, 1, 0],
        [1, 0, 0],
      ],
      [
        [0, 1, 1],
        [1, 0, 0],
        [0, 0, 1],
      ],
    ],
    type: parseInt("0101", 2),
  },
  STAIR_B: {
    vertices: [
      [
        [1, 0.25, 0.25],
        [0, 0.25, 0.25],
        [0, 0.5, 0.25],
      ],
      [
        [1, 0.25, 0.25],
        [0, 0.5, 0.25],
        [1, 0.5, 0.25],
      ],
      [
        [1, 0.5, 0.5],
        [0, 0.5, 0.5],
        [0, 0.75, 0.5],
      ],
      [
        [1, 0.5, 0.5],
        [0, 0.75, 0.5],
        [1, 0.75, 0.5],
      ],
      [
        [1, 0.75, 0.75],
        [0, 0.75, 0.75],
        [0, 1, 0.75],
      ],
      [
        [1, 0.75, 0.75],
        [0, 1, 0.75],
        [1, 1, 0.75],
      ],
      [
        [1, 0.25, 0],
        [0, 0.25, 0],
        [0, 0.25, 0.25],
      ],
      [
        [1, 0.25, 0],
        [0, 0.25, 0.25],
        [1, 0.25, 0.25],
      ],
      [
        [1, 0.5, 0.25],
        [0, 0.5, 0.25],
        [0, 0.5, 0.5],
      ],
      [
        [1, 0.5, 0.25],
        [0, 0.5, 0.5],
        [1, 0.5, 0.5],
      ],
      [
        [1, 0.75, 0.5],
        [0, 0.75, 0.5],
        [0, 0.75, 0.75],
      ],
      [
        [1, 0.75, 0.5],
        [0, 0.75, 0.75],
        [1, 0.75, 0.75],
      ],
      [
        [1, 1, 0.75],
        [0, 1, 0.75],
        [0, 1, 1],
      ],
      [
        [1, 1, 0.75],
        [0, 1, 1],
        [1, 1, 1],
      ],
      [
        [1, 0, 0],
        [1, 1, 0],
        [1, 1, 1],
      ],
      [
        [1, 0, 0],
        [1, 1, 1],
        [1, 0, 1],
      ],
      [
        [0, 0, 0],
        [0, 1, 0],
        [0, 1, 1],
      ],
      [
        [0, 0, 0],
        [0, 1, 1],
        [0, 0, 1],
      ],
    ],
    surfaces: [
      [
        [0, 0.75],
        [1, 0.75],
        [1, 0.5],
      ],
      [
        [0, 0.75],
        [1, 0.5],
        [0, 0.5],
      ],
      [
        [0, 0.5],
        [1, 0.5],
        [1, 0.25],
      ],
      [
        [0, 0.5],
        [1, 0.25],
        [0, 0.25],
      ],
      [
        [0, 0.25],
        [1, 0.25],
        [1, 0],
      ],
      [
        [0, 0.25],
        [1, 0.0],
        [0, 0],
      ],
      [
        [0, 2],
        [1, 2],
        [1, 1.75],
      ],
      [
        [0, 2],
        [1, 1.75],
        [0, 1.75],
      ],
      [
        [0, 1.75],
        [1, 1.75],
        [1, 1.5],
      ],
      [
        [0, 1.75],
        [1, 1.5],
        [0, 1.5],
      ],
      [
        [0, 1.5],
        [1, 1.5],
        [1, 1.25],
      ],
      [
        [0, 1.5],
        [1, 1.25],
        [0, 1.25],
      ],
      [
        [0, 1.25],
        [1, 1.25],
        [1, 1],
      ],
      [
        [0, 1.25],
        [1, 1],
        [0, 1],
      ],
      [
        [-1, 2],
        [0, 2],
        [0, 1],
      ],
      [
        [-1, 2],
        [0, 1],
        [-1, 1],
      ],
      [
        [-1, 2],
        [0, 2],
        [0, 1],
      ],
      [
        [-1, 2],
        [0, 1],
        [-1, 1],
      ],
    ],
    walkPoly: [
      [
        [0, 1, 1],
        [1, 1, 1],
        [1, 0, 0],
      ],
      [
        [0, 1, 1],
        [1, 0, 0],
        [0, 0, 0],
      ],
    ],
    type: parseInt("1010", 2),
  },
  // Wall
  WALL_R: {
    vertices: [
      [
        [0, 0, -2],
        [0, 1, -2],
        [0, 1, 0],
      ],
      [
        [0, 0, -2],
        [0, 1, 0],
        [0, 0, 0],
      ],
    ],
    surfaces: [
      [
        [0, 2],
        [1, 2],
        [1, 0],
      ],
      [
        [0, 2],
        [1, 0],
        [0, 0],
      ],
    ],
    type: parseInt("1011", 2),
  },
  WALL_T: {
    vertices: [
      [
        [0, 1, -2],
        [1, 1, -2],
        [1, 1, 0],
      ],
      [
        [0, 1, -2],
        [1, 1, 0],
        [0, 1, 0],
      ],
    ],
    surfaces: [
      [
        [0, 2],
        [1, 2],
        [1, 0],
      ],
      [
        [0, 2],
        [1, 0],
        [0, 0],
      ],
    ],
    type: parseInt("0111", 2),
  },
  WALL_L: {
    vertices: [
      [
        [1, 1, -2],
        [1, 0, -2],
        [1, 0, 0],
      ],
      [
        [1, 1, -2],
        [1, 0, 0],
        [1, 1, 0],
      ],
    ],
    surfaces: [
      [
        [0, 2],
        [1, 2],
        [1, 0],
      ],
      [
        [0, 2],
        [1, 0],
        [0, 0],
      ],
    ],
    type: parseInt("1110", 2),
  },
  WALL_B: {
    vertices: [
      [
        [1, 0, -2],
        [0, 0, -2],
        [0, 0, 0],
      ],
      [
        [1, 0, -2],
        [0, 0, 0],
        [1, 0, 0],
      ],
    ],
    surfaces: [
      [
        [0, 2],
        [1, 2],
        [1, 0],
      ],
      [
        [0, 2],
        [1, 0],
        [0, 0],
      ],
    ],
    type: parseInt("1101", 2),
  },
};
